import React, { useEffect, useState } from 'react';
import { Button } from '@components';
import { Card, Form, Row, Col, ButtonGroup } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { messageError, messageToast } from '../../utils/define';
import { loaiYeuCauGetItemAction, editLoaiYeuCauAction } from '../../store/reducers/loaiyeucau';
import ReactSpinner from '../../components/reactSpinner/ReactSpinner';

const schema = yup.object().shape({
    name: yup.string().required(messageError.emptyMessage)
});

const LoaiYeuCauEdit = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();

    const loaiYeuCauItem = useSelector((state) => state.loaiyeucau.loaiYeuCauItem);

    const [isLoading, setIsLoading] = useState(false);
    const [idLoaiYeuCau, setIdLoaiYeuCau] = useState('');

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const id = params.get('id');
        if (id) {
            setIdLoaiYeuCau(id);
            dispatch(loaiYeuCauGetItemAction(id));
        }
    }, [dispatch, location.search]);

    const handleEdit = async (values) => {
        const modelUpdate = { data: values, id: idLoaiYeuCau };

        try {
            const result = await dispatch(editLoaiYeuCauAction(modelUpdate));
            if (result.payload !== 200) {
                toast.error(messageToast.messageToastUpdateError);
            } else {
                setIsLoading(true);
                toast.success(messageToast.messageToastUpdateSuccess);
                history.goBack();
            }
        } catch (error) {
            toast.error('Đã có lỗi xảy ra, vui lòng thử lại !');
        }
    };

    return (
        <Card>
            <Card.Header as="h5">Sửa loại yêu cầu</Card.Header>
            <Card.Body>
                {loaiYeuCauItem == null ? (
                    <div>Loại yêu cầu không tồn tại</div>
                ) : (
                    <Formik
                        enableReinitialize
                        validationSchema={schema}
                        onSubmit={(values) => handleEdit(values)}
                        initialValues={{
                            name: loaiYeuCauItem?.name || ''
                        }}
                    >
                        {({ handleSubmit, handleChange, values, errors }) => (
                            <Form noValidate onSubmit={handleSubmit}>
                                <Form.Group as={Row} className="mb-3">
                                    <Form.Label className="col-sm-2 col-form-label">Tên loại yêu cầu *</Form.Label>
                                    <Col sm="10">
                                        <Form.Control
                                            placeholder="Tên loại yêu cầu"
                                            type="text"
                                            name="name"
                                            value={values.name}
                                            onChange={handleChange}
                                            isInvalid={!!errors.name}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.name}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>

                                <Form.Group as={Row} className="mb-3">
                                    <Col md={{ span: 10, offset: 2 }}>
                                        <ButtonGroup>
                                            <Button type="submit" theme="primary" disabled={isLoading}>
                                                Sửa
                                            </Button>
                                            &nbsp;&nbsp;&nbsp;
                                            <Button onClick={() => history.goBack()} theme="secondary">
                                                Hủy
                                            </Button>
                                        </ButtonGroup>
                                    </Col>
                                </Form.Group>
                            </Form>
                        )}
                    </Formik>
                )}

                <ReactSpinner loadings={isLoading} />
            </Card.Body>
        </Card>
    );
};

export default LoaiYeuCauEdit;